export function updateCurrentLaunchTypeCookieValue(value) {
    const props = {
        CookieName: "IVALaunchType=",
        Type: value,
    };
    const currentCookieValue = getCurrentLaunchTypeCookieValue();
    if (currentCookieValue !== value) {
        setCurrentLaunchTypeCookieValue(props);
    }
}
export function getCurrentLaunchTypeCookieValue() {
    const cookieName = "IVALaunchType=";
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return currentFocusedCookie.substring(cookieName.length + 1, currentFocusedCookie.length);
        }
    }
    return "";
}
function setCurrentLaunchTypeCookieValue(props) {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    const expireTime = "expires=" + cookieExpirationDate.toUTCString();
    if (props.Type === "Reactive") {
        document.cookie = props.CookieName + "Manual" + ";" + expireTime + ";path=/";
    }
    else if (props.Type === "Proactive") {
        document.cookie = props.CookieName + "Auto" + ";" + expireTime + ";path=/";
    }
    else {
        document.cookie = props.CookieName + "Unknown" + ";" + expireTime + ";path=/";
    }
}
export function deleteCurrentLaunchTypeCookie() {
    document.cookie = "IVALaunchType=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
